<template>
    <div class="page-index">
        <div class="hd">
            <div class="bg"></div>
        </div>
        <div class="bd">
            <div class="box">
                <div class="box-hd">
                    <div class="box-hd-label">订单总额</div>
                    <div class="box-hd-value">{{ totalFee }}元</div>
                </div>
                <div class="box-bd">
                    <div class="box-item">
                        <div class="box-bd-label">科室</div>
                        <div class="box-bd-value">{{ deptName }}</div>
                    </div>
                    <div class="box-item">
                        <div class="box-bd-label">病人姓名</div>
                        <div class="box-bd-value">{{ name }}</div>
                    </div>
                    <div class="box-item">
                        <div class="box-bd-label">支付类型</div>
                        <div class="box-bd-value">{{ payType }}</div>
                    </div>
                </div>
            </div>
            <div class="bd-ft-success">
                <van-button type="primary" round block @click="doPay">支付完成</van-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {getQueryString} from "../../utils/common";
    import {getOrderInfo} from "../../api/Api";
    import {Toast} from "vant";

    export default {
        name: 'PageIndex',
        data() {
            return {
                openId: '',
                totalFee: '',
                deptName: '',
                name: '',
                payType: '',
                medOrgOrd: '',
            }
        },
        methods: {
            doPay() {
                window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbbbf21ec24a1b219&redirect_uri=https%3A%2F%2Fkt.tgzzykj.cn%2Fyy%2Fwx%2F&response_type=code&scope=snsapi_base&state=STATE#wechat_re";
            }
        },
        mounted: function () {
            this.$nextTick(async function () {
                window.document.title = "医保移动支付";
                this.medOrgOrd = getQueryString("medOrgOrd")
                let p = {
                    medOrgOrd: this.medOrgOrd,
                }
                let ret = await getOrderInfo(p);
                if (ret.status !== 200) {
                    Toast.fail("查询订单信息失败！")
                    return;
                }
                this.totalFee = ret.data.totalFee
                this.deptName = ret.data.deptName
                this.name = ret.data.name
                this.payType = ret.data.payType
            })
        }
    }
</script>

<style scoped>
    @import '../../assets/index.css';
    @import '../../assets/actionsheet.css';

    .van-button--primary {
        color: #fff;
        background-color: #1989fa;
        border: 1px solid #1989fa;
    }

    .bd-ft-success {
        display: flex;
        justify-content: space-between;
        padding-top: 20px;
        padding-bottom: 17px;
        font-size: 16px;
        color: #3B71E8;
        width: 92%;
        margin: auto;
    }
</style>
